module.exports = __webpack_public_path__ + "static/media/orange_wave.01643ccb.svg";